export enum CourseLinkTypes {
  lernaCourse = 'lerna_course',
  vendorCourse = 'vendor_course',
  lernaVendorCourse = 'lerna_vendor_course',
}
